import Properties from "../properties";
import ApiService from "./shared/ApiService";
import ApiService2 from "./shared/ApiService2";

const ConsultaService = {
  /**
   * Serviço para buscar dados da carteira
   * dado o protocolo.
   */
  buscarDadosCarteira: protocolo =>
    ApiService.query(`${Properties.BASE_URL}/api/public/informacao-carteira`, {
      protocolo
    }),

  fetchPaises: () =>
    ApiService.query(`${Properties.BASE_URL}/api/public/fetch-paises`),

  fetchEstados: () =>
    ApiService.query(`${Properties.BASE_URL}/api/public/fetch-estados`),

  fetchMunicipiosPorEstado: idEstado =>
    ApiService.get(
      `${Properties.BASE_URL}/api/public/fetch-municipios/${idEstado}`
    ),

  consultarMinhaCarteira: () =>
    ApiService2.get(`/api/consultar-minha-carteira`),

  consultarHistoricoCarteira: identificador =>
    ApiService2.get(
      `/api/external/carteira/historico/byIdentificador/${identificador}`
    )
};

export default ConsultaService;
